import script from "./EstimationParamPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EstimationParamPage.vue?vue&type=script&setup=true&lang=ts"

import "./EstimationParamPage.vue?vue&type=style&index=0&id=520adbf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520adbf0"]])

export default __exports__